import { NavLink } from "react-router-dom";
import { Home, Compass, Plus, Bell, User } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const items = [
  { to: "/app", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/app/discover", icon: Compass, label: "Discover", testid: "nav-discover" },
  { to: "/app/upload", icon: Plus, label: "Upload", testid: "nav-upload", accent: true },
  { to: "/app/notifications", icon: Bell, label: "Notifications", testid: "nav-alerts" },
  { to: "/app/me", icon: User, label: "Profile", testid: "nav-profile" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    if (!user) return;
    const load = async () => {
      try {
        const { data } = await api.get("/notifications");
        setUnread(data.unread || 0);
      } catch {}
    };
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [user]);
  if (!user) return null;
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 inset-x-0 z-40 h-16 glass border-t border-zinc-800/80">
      <div className="max-w-2xl mx-auto h-full grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, testid, accent }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/app"}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] transition-colors duration-200 relative ${
                isActive ? "text-[#DC2626]" : "text-zinc-400 hover:text-zinc-100"
              }`
            }
          >
            {accent ? (
              <div className="w-11 h-11 -mt-4 rounded-full bg-[#DC2626] text-black flex items-center justify-center shadow-lg shadow-[#DC2626]/20">
                <Icon size={22} strokeWidth={2.5} />
              </div>
            ) : (
              <>
                <Icon size={20} strokeWidth={2} />
                {unread > 0 && (
                  <span data-testid="unread-badge" className="absolute top-2 right-1/2 translate-x-4 w-4 h-4 bg-red-500 text-white text-[9px] rounded-full flex items-center justify-center">{unread}</span>
                )}
              </>
            )}
            {!accent && <span>{label}</span>}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
